<template>
  <v-chip
    v-if="requestVacationsBadgeQTY"
    color="red"
    text-color="white"
    small
    >{{ requestVacationsBadgeQTY }}</v-chip
  >
</template>

<script>
import { mapState } from 'vuex';
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'RequestVacationBadge',

  components: {},

  data: () => ({}),

  computed: {
    ...mapState('request_vacations', ['requestVacationsBadgeQTY'])
  },

  mounted() {
    this.getQTYRequestVacations();
    this.getActualQTYRequestVacations();
  },

  methods: {
    ...mapCacheActions('request_vacations', [
      'getQTYRequestVacations',
      'getActualQTYRequestVacations'
    ])
  }
};
</script>
